import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { VersionChip } from '~/components/Chip/VersionChip';
import {
    DoseTargetData,
    transformDoseTargets,
} from '~/utils/transforms/doseTargetsTransforms';

type ModelDetailsProps = {
    modelName?: string;
    targets?: DoseTargetData[];
    version?: string;
    isLatest?: boolean;
};

export default function ModelParameters({
    modelName,
    targets,
    version,
    isLatest,
}: ModelDetailsProps) {
    const selectedTargets = transformDoseTargets(targets ?? []);
    return (
        <Box>
            {modelName && (
                <>
                    <Typography variant="body2" color="primary" fontSize={12}>
                        <FormattedMessage id="selectedModel" />:
                    </Typography>

                    <Box
                        display="grid"
                        gridTemplateColumns="1fr auto"
                        gap={1}
                        alignItems="center"
                        mr={2}
                    >
                        <Typography
                            fontSize={14}
                            sx={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                cursor: 'pointer',
                            }}
                        >
                            {modelName}
                        </Typography>
                        {version && (
                            <VersionChip
                                version={version}
                                isLatest={isLatest}
                            />
                        )}
                    </Box>

                    {selectedTargets && (
                        <Typography fontSize={12} color="textSecondary">
                            with {selectedTargets ? selectedTargets.length : 0}{' '}
                            targets
                        </Typography>
                    )}
                </>
            )}
        </Box>
    );
}
